import { numberWithCommas } from 'common/helpers/numberHelper';
import { useLocalization } from 'redux/localization/utils/hooks';

const PointsSummary = (props) => {
  const { cartOrOrder } = props;
  const { t } = useLocalization();
  const { items } = cartOrOrder;

  let points = 0;
  items.forEach((item) => {
    if (item.itemData?.loyaltyPoints) {
      points += item.itemData.loyaltyPoints * item.quantity;
    }
  });

  if (points > 0) {
    return (
      <>
        <div className="c7-order-summary__item--notes">
          <div className="c7-order-summary__title">
            {t('general.loyalty.points')}
          </div>
          <div className="c7-order-summary__value">
            {numberWithCommas(points)}
          </div>
        </div>
      </>
    );
  }

  return null;
};

export default PointsSummary;
